import { useMemo } from 'react';
import { capitalizeFirstLetter } from '@common-fe/common-fe';

import regexp from '@/common/regexp';

import { InvestmentStatus, InvestmentStatusPayload } from '../EnrollmentInvestments.types';

const useGetInvestorFormattedData = (investor: InvestmentStatusPayload | null) => {
  const riskModel = useMemo(
    () =>
      investor?.riskToleranceModel
        ? investor.riskToleranceModel
            .split(regexp.DASH_SYMBOL)
            .map((item: string) => capitalizeFirstLetter(item))
            .join(' ')
        : undefined,
    [investor]
  );
  const investmentType = useMemo(
    () =>
      investor?.type
        ? investor.type
            .split(regexp.DASH_SYMBOL)
            .map((item: string) => capitalizeFirstLetter(item))
            .join(' ')
        : undefined,
    [investor]
  );
  const investorStatus = useMemo(() => {
    if (!investor?.status || investor?.status === InvestmentStatus.INVESTOR_CREATED) {
      return {
        color: 'textDisabled',
        text: 'Not Enrolled',
      };
    }
    if (investor?.status === InvestmentStatus.ACTIVE) {
      return {
        color: 'success',
        text: 'Active',
      };
    }
    return {
      color: 'textBody',
      text: 'Pending',
    };
  }, [investor]);
  const isPendingStatus = useMemo(() => {
    return (
      investor?.status !== InvestmentStatus.INVESTOR_CREATED && investor?.status !== InvestmentStatus.ACTIVE
    );
  }, [investor?.status]);
  const isNotEnrolledStatus = useMemo(() => {
    return investor?.status === InvestmentStatus.INVESTOR_CREATED;
  }, [investor?.status]);
  return {
    isNotEnrolledStatus,
    isPendingStatus,
    investorStatus,
    riskModel,
    investmentType,
  };
};

export default useGetInvestorFormattedData;
